const base = "";

export const ROUTE_HOME = base + "/:locale";
export const ROUTE_PROYECTOS = base + "/:locale/proyectos/";
export const ROUTE_PRODUCTO = base + "/:locale/producto/:producto";